<template>
  <v-main>
    <v-container fluid>
      <v-row dense>
        <v-col cols="12">
          <v-card color="#1976d2">
            <v-card-title primary-title class="white--text">
              <div>
                <h3 class="headline mb-2">
                  Индикаторы
                </h3>
              </div>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-card>
            <v-col cols="12">
              <v-row align="center"
                     justify="center"
                     no-gutters>
                <v-col cols="2" class=".d-sm-none .d-md-flex">
                  <v-select
                    v-model="yearsSelected"
                    :items="yearsAvailable"
                    small-chips
                    multiple
                    chips
                    label="Отчетные года" />
                </v-col>
                <v-col cols="8">
                  <BaseControlElement :is-dates-active="yearsSelected.length > 0"
                                      :is-places-list="false"
                                      :is-projects="false"
                                      :lowest-date.sync="lowestDate"
                                      :highest-date.sync="highestDate"
                                      :places-selected.sync="placesSelected"
                                      :selected-projects.sync="projectsSelected"
                                      @submitSearch="submitSearch" />
                </v-col>
              </v-row>
            </v-col>
          </v-card>
          <v-card v-if="loading">
            <v-skeleton-loader
              type="card-title, card-avatar, article" />
          </v-card>
          <v-card v-if="!loading && customers.length>0">
            <v-card-title>
              <v-row dense justify="center">
                <v-col cols="3">
                  <v-select
                    v-model="projectsSelected"
                    :items="projects"
                    item-text="name"
                    item-value="name"
                    multiple
                    chips
                    small-chips
                    label="Проекты" />
                </v-col>
                <v-col cols="3">
                  <v-select
                    v-model="groupsSelected"
                    :items="customerGroups"
                    item-text="name"
                    item-value="name"
                    multiple
                    chips
                    small-chips
                    label="Типы клиентов" />
                </v-col>
                <v-col cols="3">
                  <BaseAutoComplete
                    :items="placesAvailable"
                    :value="placesSelected"
                    @updateSelected="updatePlaces"
                    style="margin-left: 20px;"
                    label="Места выхода" />
                </v-col>
              </v-row>
            </v-card-title>

            <v-col justify="center">
              <v-col cols="10" justify="center" offset="1">
                <ReportIndicatorCustomers :data="customersTable" :loading="loading" />
              </v-col>
              <v-row>
                <v-col cols="10">
                  Всего шприцев: {{ syringesAll }}
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="3">
                  <ReportIndicatorProducts :data="productsFiltered" :loading="loading" />
                </v-col>
                <v-col cols="3">
                  <ReportIndicatorConsult :data="consultFiltered" :loading="loading" table-name="Консультации" />
                </v-col>
                <v-col cols="3">
                  <ReportIndicatorConsult :data="directionsFiltered" :loading="loading" table-name="Направления" />
                </v-col>
                <v-col cols="3">
                  <v-card style="min-height: 250px">
                    <v-col>
                      <v-list-group
                        v-for="test in testsFiltered"
                        :key="`test-${test.project}-${test.name}`"
                        :value="true"
                        no-action
                        sub-group>
                        <template v-slot:activator>
                          <v-list-item-content>
                            <v-list-item-title>{{ test.name }}</v-list-item-title>
                          </v-list-item-content>
                        </template>
                        <v-list-item>
                          <v-list-item-title> Положительных: <b>{{ test['Положительный'] ? test['Положительный'].amount : 0 }}</b> </v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-title> Отрицательных: <b>{{ test['Отрицательный'] ? test['Отрицательный'].amount : 0 }} </b></v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-title>
                            Всего: <b>{{ (test['Отрицательный'] ? test['Отрицательный'].amount : 0 ) + (test['Положительный'] ? test['Положительный'].amount :0) }}</b>
                            (Кодов :<b>{{ test['Отрицательный']['customers'] }}</b>)
                          </v-list-item-title>
                        </v-list-item>
                      </v-list-group>
                    </v-col>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-card>
          <v-card v-if="customers.length===0">
            <v-card-title>
              <v-row dense justify="center">
                Нажмите "ПОИСК"
              </v-row>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from 'axios'
import ReportIndicatorCustomers from './ReportIndicatorCustomers'
import ReportIndicatorProducts from './ReportIndicatorProducts'
// import ReportIndicatorConsult from './ReportIndicatorConsult'
import BaseControlElement from '../../../base/BaseControlElement'
import BaseAutoComplete from '../../../base/BaseAutoComplete'
import {authHeader} from '../../../../_helpers/auth-header'
import {mapState} from 'vuex'
import ReportIndicatorConsult from './ReportIndicatorConsult'

export default {
  name: "ReportController",
  components: {
    ReportIndicatorConsult,
    BaseControlElement,
    BaseAutoComplete,
    ReportIndicatorCustomers,
    ReportIndicatorProducts
    // ReportIndicatorConsult,

  },
  props: {
    report: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selectedYear: null,
      placesSelected: [],
      gendersSelected: [],
      projectsSelected: [],
      groupsSelected: [],
      selectedProjects: [],

      perProject: null,
      genders: [],
      lowestDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10),
      highestDate: new Date().toISOString().substr(0, 10),
      yearsSelected: '',
      loading: false,
      customers: [],
      tests: [],
      products: [],
      directions: [],
      consults: [],
      contacts: [],
      tab: null,
      chartData: {},
      loaded: false,
      chartOptions: {
        hoverBorderWidth: 20,
        legend: {
          display: true,
          position: 'left',
          labels: {
            fontSize: 10
          }
        }
      }
    }
  },
  computed: {
    customersFiltered (){

      let cust = this.customers
      if (this.projectsSelected.length>0) {
        cust = cust.filter(v => this.projectsSelected.indexOf(v.project)>-1)
      }
      if (this.groupsSelected.length>0) {
        cust = cust.filter(v => this.groupsSelected.some(r => v.group.indexOf(r) >= 0))
      }
      if (this.placesSelected.length > 0) {
        // custProj = custProj.filter(v => this.placesSelected.indexOf(v.place)>-1)
        cust = cust.filter(v => this.placesSelected.indexOf(v.place)>-1)
      }
      return cust
    },
    contactsFiltered () {
      let contacts = this.contacts
      if (this.projectsSelected.length>0) {
        contacts = contacts.filter(v => this.projectsSelected.indexOf(v.project)>-1)
      }
      if (this.groupsSelected.length>0) {
        contacts = contacts.filter(v => this.groupsSelected.some(r => v.group && v.group.indexOf(r) >= 0))
      }
      if (this.placesSelected.length > 0) {
        contacts = contacts.filter(v => this.placesSelected.indexOf(v.place)>-1)
      }
      return contacts
    },
    placesAvailable () {
      let custPl = this.customers.map(v => v.place).filter((v, i, a) => a.indexOf(v) === i)
      return this.places.filter(v => custPl.indexOf(v.id)>-1)
    },
    yearsAvailable () {
      let currentYear = new Date().getFullYear(), years = []
      let startYear = 2018
      while (startYear <= currentYear) {
        years.push(startYear++)
      }
      return years
    },
    customersPerGender () {
      return this.customersFiltered.length > 0 ? this.customersFiltered.reduce(function (r, a) {
        r[a.gender] = r[a.gender] || []
        r[a.gender].push(a)
        return r
      }, Object.create(null)) : []
    },
    customersTable () {
      let perGender = this.customersFiltered.reduce(function (r, a) {
        r[a.gender] = r[a.gender] || []
        r[a.gender].push(a)
        return r
      }, Object.create(null))
      let d = {}
      Object.entries(perGender).map(v => {
        d[v[0]] = v[1].reduce(function (r, a) {
          r[a.const] = r[a.const] || []
          r[a.const].push(a)
          return r
        }, Object.create(null))
        return d
      })
      // data['new_М']+data['new_Ж']+data['new_Т']
      let tableData = {}
      let vm = this
      Object.keys(d).forEach(key => {
        let newC = d[key][0] ? d[key][0].length : 0
        let oldC = d[key][1] ? d[key][1].length : 0
        tableData[key] = newC + oldC
        tableData['new_' + key] = newC
        tableData['constant_' + key] = oldC
        tableData['contacts_' + key] = vm.contactsFiltered.filter(v => v.gender === key).reduce(function (sum, current) {
          return sum + current.amount
        }, 0)
      })
      return tableData
    },
    productsFiltered () {
      return this.filterServices(this.products)
    },
    syringesAll () {
      return this.productsFiltered.filter(v => v.name.includes('шприц')).reduce((accumulator, syringeType) => {
        return accumulator + parseInt(syringeType.value)
      }, 0)
    },
    consultFiltered () {

      return this.filterServices(this.consults)
    },
    directionsFiltered () {
      return this.filterServices(this.directions)
    },
    testsFiltered () {
       let tests = this.tests
        if (this.projectsSelected.length > 0) {
        tests = this.tests.filter(v => {
          return this.projectsSelected.indexOf(v.project) > -1
        })
      }
      if (this.groupsSelected.length > 0) {
        tests = tests.filter(v => {
         return  this.groupsSelected.indexOf(v.group) > -1
        })
      }
      if (this.placesSelected.length > 0) {
        tests = tests.filter(v => {
          return this.placesSelected.indexOf(v.place) > -1
        })
      }
      let dict = {}
      tests.forEach(function (d) {
        let res = d.result>0 ? 'Положительный' : 'Отрицательный'
        if (dict.hasOwnProperty(d.name) ) {
          if (dict[d.name][res]) {
            dict[d.name][res] = {'amount':dict[d.name][res]['amount']+ d.amount,'name':d.name, 'customers':dict[d.name][res]['customers']+d.customers}
          }
          else  {
            dict[d.name][res] = {'amount':d.amount,'name':d.name, 'customers':d.customers}
          }
        } else {
          dict[d.name] = {'name':d.name}
          dict[d.name][res] ={'amount':d.amount,'customers':d.customers}
        }
      })

      return dict
    },
    ...mapState({
    projects: state => state.tableData.projects,
    customerGroups: state => state.tableData.customerGroups,
    places: state => state.tableData.places

  })
  },
  created () {
    this.$store.dispatch("tableData/loadProjects")
    this.$store.dispatch("tableData/loadCustomerGroups")
  },
  methods: {
    updatePlaces (newVal) {
      this.placesSelected = newVal
    },
    filterServices (services) {
      let prods = services
      if (this.projectsSelected.length > 0) {
        prods = prods.filter(v => {
          return this.projectsSelected.indexOf(v.project) > -1
        })
      }
      if (this.groupsSelected.length > 0) {
        prods = prods.filter(v => {
          return this.groupsSelected.indexOf(v.group) > -1
        })
      }
      if (this.placesSelected.length > 0) {
        prods = prods.filter(v => {
          return this.placesSelected.indexOf(v.place) > -1
        })
      }

      let dict = {}
      let res = []
      let pr = prods.map(v => {
        let d = {}
        d['name'] = v.name
        d['amount'] = v.amount
        if (v.report_type) {
          d['report_type'] = v.report_type
           d['report_type_group'] = v.report_type_group
        }

        return d
      })
      pr.forEach(function (d) {
        if (dict.hasOwnProperty(d.name)) {
            let amnt = 0
            if (dict[d.name].hasOwnProperty('amount')) amnt = dict[d.name]['amount']
            dict[d.name]['amount'] = amnt + d.amount
        } else {
          dict[d.name] = {'amount':d.amount,'report_type_group':d.report_type_group,'report_type':d.report_type}
        }
      })
      //console.log(dict)
      for (var prop in dict) {
        //console.log(prop)
        res.push({name: prop, value: dict[prop]['amount'],report_type:dict[prop]['report_type'],report_type_group:dict[prop]['report_type_group']})
      }
      //console.log(res)
      return res
    },
    submitSearch () {
      this.loading = true
      const requestOptions = {
        method: 'GET',
        headers: authHeader()
      }

      axios({
        url: this.$store.state.tableData.backend + '/report/indicators',
        headers: requestOptions['headers'],
        method: 'post',
        data: {
          placesSelected: this.placesSelected,
          gendersSelected: this.gendersSelected,
          lowestDate: this.lowestDate,
          highestDate: this.highestDate,
          yearsSelected: this.yearsSelected
        }

      }).then((response) => {
        this.loading = false
        let indicatorsData = response.data.data
        this.customers = indicatorsData.customers
        this.products = indicatorsData.products
        this.consults = indicatorsData.consults
        this.directions = indicatorsData.directions
        this.tests = indicatorsData.tests
        this.contacts = indicatorsData.contacts
        // this.perProject = response.data.perProject
        this.loaded = true
        // this.chartData.labels = response.data.chartData['labels']
        // this.chartData['datasets'] = response.data.chartData['data']

        // this.$nextTick(() => {
        //   this.$refs['pieChart'].updateChart()
        // })
      }).catch(() => {

        throw new Error(`You can't load the data`)
      })
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/pages/indicators/ReportController.vue